import Provider from "../Provider";
import SedeContextType from "./SedeContextType";

export default interface SedeProvider extends Provider<SedeContextType> {}

export const SedeProviderName = "SedeProvider";
